module.exports = __webpack_public_path__ + "static/media/proj15_img11.5d18395d.jpg";